import { Router } from '@angular/router';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dialog-message',
  templateUrl: './dialog-message.component.html',
  styleUrls: ['./dialog-message.component.scss']
})
export class DialogMessageComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  error = `${this.RESOURCE_SERVER_URL}/assets/images/distributions/Navigation_icons/DMS_icons/Branch.svg`;
  success = `${this.RESOURCE_SERVER_URL}/assets/images/Tick.svg`;


  visible = false;
  detail: { [unit: string]: any } = {};
  underwriterid;
  data_icons = [
    { label: 'error', img: this.error }
  ]
  icon;

  @Output() onCloseClick = new EventEmitter<any>();


  constructor(public dialogRef: MatDialogRef<DialogMessageComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.fetchIcon()
  }

  ngOnInit(): void {
    this.detail = this.data;

  }

  fetchIcon() {
    switch (this.data.icon) {
      case 'error':
        this.data.icon = this.error;
        break;
      case 'success':
        this.data.icon = this.success;
        break;
      case 'channelProduct':
        break;

      default:
        break;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
  requestCloseTimeout() {
    if (this.data['reqClose']) {
      window.setTimeout(() => {
        this.closeDialog();
      }, this.data['timeOut']);
    }
  }

  btnSave() {
    this.onCloseClick.emit(true);
  }

  onClose() {
    this.dialogRef.close();
    this.router.navigate(['/process-claims']);
  }

}
